import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowLeftUpCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-left-up-circle"} maskId="square-filled-radius-0-stroke-1-IconArrowLeftUpCircle"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8 8H15V9H9.70711L16.2071 15.5L15.5 16.2071L9 9.70711V15H8L8 8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowLeftUpCircle;
